$(function () {
    $('.dropdown-toggle').dropdown();

    $('[data-toggle="modal"]').on('click', function (e) {
        e.preventDefault();
        let target = $(this).data('target');
        $(target).modal('show');
    });

    $('[data-dismiss="modal"]').on('click', function (e) {
        e.preventDefault();
        let target = $(this).closest('.modal');
        $(target).modal('hide');
    });
});
